// extracted by mini-css-extract-plugin
export var currencyInput = "_l9-1";
export var currencySymbol = "_l9-0";